function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgBackIcon = function SvgBackIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 31 30",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M37 13.5H9.7L21.6 1.3 20.5.2 7 14.2l13.5 15.1 1.1-1L9.7 15H37z",
    style: {
      fill: "#222"
    }
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBackIcon);
export default ForwardRef;